export default "__VITE_ASSET__DxDWPnZB__"